import request from '@/utils/request'

// 奖金转电子币 分页  代办处/经销商
export function pageByDTO(query) {
    return request({
        url: '/acFbexcash/pageByDTO',
        method: 'get',
        params: query
    })
}

// 奖金转电子币 集合  代办处/经销商
export function listByDTO(query) {
    return request({
        url: '/acFbexcash/listByDTO',
        method: 'get',
        params: query
    })
}

// 奖金转电子币 取消  代办处/经销商
export function cancelById(query) {
    return request({
        url: '/acFbexcash/cancelById',
        method: 'delete',
        params: query
    })
}

// 奖金转电子币 新增  代办处/经销商
export function addByDTO(data) {
    return request({
        url: '/acFbexcash/addByDTO',
        method: 'post',
        data
    })
}
